









// first open stage that is navigable or last completed stage that is navigable
const findBestNavigableStage = (
  phases
) => {
  if (!phases) {
    return undefined
  }

  let lastClosed





 = undefined

  for (let i = 0; i < phases.length; ++i) {
    const phase = phases[i]
    const {stages} = phase

    for (let j = 0; j < stages.length; ++j) {
      const stage = stages[j] 
      if (!stage.isNavigable) {
        continue
      }
      if (!stage.isComplete) {
        return {phase, stage, stageIdx: j}
      } else {
        lastClosed = {
          phase,
          stage,
          stageIdx: j
        }
      }
    }
  }
  return lastClosed
}

export default findBestNavigableStage
